import { LinearProgress, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

interface ReportPdfProps {
  shiftId: number;
}

interface ReportPdfState {
  loading: boolean;
  pdf: any;
}

const DEFAULT_STATE: ReportPdfState = {
  loading: true,
  pdf: null,
};
export default function ReportPdf({ shiftId }: ReportPdfProps) {
  console.log(
    "🚀 ~ file: ReportPdf.tsx ~ line 26 ~ ReportPdf ~ shiftId",
    shiftId
  );
  const [state, setState] = useState<ReportPdfState>(DEFAULT_STATE);
  useEffect(() => {
    console.log("getting report");
    axios
      .get(
        `https://us-central1-ioloc-dev.cloudfunctions.net/report-generation-dev-generate_report_pdf/?shiftId=${shiftId}`,
        { responseType: "arraybuffer" }
      )
      .then((resp) => {
        console.log(
          "🚀 ~ file: ReportPdf.tsx ~ line 23 ~ useEffect ~ resp",
          resp
        );
        const pdf = resp.data;
        const file = new Blob([pdf], {
          type: "application/pdf",
        });
        const fileURL = URL.createObjectURL(file);
        var len = pdf.length;

        let bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
          bytes[i] = pdf.charCodeAt(i);
        }
        let b64 = resp.data;
        //var bin = atob(b64);

        const renderPdf = bytes.buffer;
        setState({ ...state, loading: false, pdf: fileURL });
      });
  }, []);

  if (state.loading) {
    return <LinearProgress />;
  } else {
    return (
      <Container>
        {/* <Document file={{ data: state.pdf }}>
          <Page pageNumber={1} />
        </Document> */}
        <a href={state.pdf} download="Report.pdf">
          <Typography>Download Here</Typography>
        </a>
      </Container>
    );
  }
}
